/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Body } from '../../Layouts/Body'
import { WhiteContainer } from '../../../components/WhiteContainer'
import { appApi } from '../../../services/appApi'
import { Box, Divider, Flex, Grid, Img, Radio, RadioGroup, Text, useToast } from '@chakra-ui/react'
import { ButtonCmp } from '../../../components/ButtonCmp'
import { TimelineFeedback } from '../Timeline'
import { iCompetencia, iItemFeedbackResponse, iPesquisaPercepcaoFeedbackResponse, iPostNineBox, iQuestao } from '../../../interfaces'
import { CardSelecao } from '../components/CardSelecao'
import { ArrayToChunks, CheckIsItemDeVisualizacao, CheckIsItemPadrao, FormatarMensagemEditorDeTexto, transformarDuracao, UpdateElementByPosition } from '../../../Utils/Helper'
import { CardItemSelecionado } from '../components/CardItemSelecionado'
import { ModalDelete } from '../../../components/ModalDelete'
import { ElementoTooltipCmp } from '../../../components/ElementoTooltipCmp'
import { FaCheckCircle, FaCog, FaEdit, FaPeopleArrows, FaSave, FaUserCheck, FaUsers } from 'react-icons/fa'
import { MdOutlineCancel } from 'react-icons/md'
import { Carousel } from 'react-responsive-carousel'
import { CheckboxCmp } from '../../../components/CheckboxCmp'
import { ImgSah } from '../../../components/ImgSah'
import { SelectCmp } from '../../../components/SelectCmp'
import { CardCompetencia } from '../components/CardCompetencia'
import { NineBox } from '../components/NineBox'
import { Main } from '../Criar/styles'
import { InputCmp } from '../../../components/InputCmp'
import { ModalPreVizualizarQuestao } from '../components/ModalPreVizualizarQuestoes'
import IconeOutros from '../../../assets/IconeOutrosAzul.svg'
import { ModalConfigurarItem } from '../components/ModalConfigurarItem'

interface iModel {
  itensPermitidos?: number[]
  itens: iItemFeedbackResponse[]
  iniciado: boolean
  itensCalibracao: number
  pesquisasDesempenho: number
}

export const OrdenarItensFeedback: React.FC = () => {
  const nav = useNavigate()
  const { id } = useParams()
  const { pathname } = useLocation()
  const toast = useToast()
  const [IsLoading, setIsLoading] = useState(false)
  const [Model, setModel] = useState<iModel>({ itens: [], itensPermitidos: [], iniciado: false, itensCalibracao: 0, pesquisasDesempenho: 0 })
  const [OrdemDelete, setOrdemDelete] = useState<{ ordem?: number, tipo: number }>()
  const [ModelNineBox, setModelNineBox] = useState<iPostNineBox>()
  const [ItemSelecionado, setItemSelecionado] = useState<number>()
  const [PreVisualizarisOpen, setPreVisualizarisOpen] = useState(false)
  const [Competencia, setCompetencia] = useState<iCompetencia>()
  const [Questoes, setQuestoes] = useState<iQuestao[]>([])
  const [PesquisasEntrada, setPesquisasEntrada] = useState<iPesquisaPercepcaoFeedbackResponse[]>([])
  const Fase = pathname.includes('Entrada') ? 0 : pathname.includes('Desenvolvimento') ? 1 : 2

  function GetModel(): void {
    setIsLoading(true)
    appApi.get(`FeedbackPersonalizado/${id}/Itens?fase=${Fase}`)
      .then((res) => setModel(res.data))
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function OnDescerItem(ord?: number): void {
    if (!ord) return

    const index = Model.itens.findIndex(ind => ind.ordem === ord)
    const indexDesceu = Model.itens.findIndex(ind => ind.ordem === (ord + 1))
    const copy = [...Model.itens]
    copy[index].ordem = ord + 1
    copy[indexDesceu].ordem = ord
    OnSave(copy, true)
  }

  function OnSubirItem(ord?: number): void {
    if (!ord) return

    const index = Model.itens.findIndex(ind => ind.ordem === ord)
    const indexSubiu = Model.itens.findIndex(ind => ind.ordem === (ord - 1))
    const copy = [...Model.itens]
    copy[index].ordem = ord - 1
    copy[indexSubiu].ordem = ord
    OnSave(copy, true)
  }

  function OnUpdate(item: iItemFeedbackResponse): void {
    const index = Model.itens.findIndex(ind => ind.id === item.id)
    if (index === -1) return
    const copy = [...Model.itens]
    copy[index] = item
    OnSave(copy, true)
  }

  function OnSelectEditarRespostas(item: iItemFeedbackResponse, val: number, checked: boolean, index?: number): void {
    let copy = item.configFormulario?.editarRespostas
    if (checked) {
      copy?.push(val)
    } else {
      copy = copy?.filter(e => e !== val)
    }
    setModel({ ...Model, itens: UpdateElementByPosition(Model.itens, index ?? 0, { ...item, configFormulario: { ...item.configFormulario, editarRespostas: copy } }) })
    onSaveItem({ ...item, configFormulario: { ...item.configFormulario, editarRespostas: copy } }, true)
  }

  function OnDeleteItem(tipo: number, ordem?: number): void {
    if (CheckIsItemDeVisualizacao(tipo)) {
      const copy = Model.itens.filter(e => e.tipo !== tipo)
      setModel({ ...Model, itens: copy })
      OnSave(copy, true)
    } else if (ordem) {
      const copy: iItemFeedbackResponse[] = []
      Model.itens.forEach(e => {
        const item = { ...e }
        if (item.ordem) {
          item.ordem = ordem < item.ordem ? item.ordem - 1 : item.ordem
        }

        if (e.ordem !== ordem) {
          copy.push(item)
        }
      })
      OnSave(copy, true)
    }
  }

  function OnSave(items: iItemFeedbackResponse[], deleteItem?: boolean): void {
    if (!deleteItem && Model.itens.length === 0) {
      toast({
        title: 'Você deve selecionar pelo menos um item para essa fase',
        duration: 4000,
        position: 'top',
        status: 'error'
      })
      return
    }

    setIsLoading(true)
    appApi.put(`FeedbackPersonalizado/${id}/Itens?fase=${Fase}`, { list: items })
      .then(() => {
        if (!deleteItem) {
          if (Fase === 0) { OnPatchStatusParticipantes(pathname.replace('Entrada', 'Desenvolvimento'), 1) } else { OnPatchStatusParticipantes(pathname.replace('Desenvolvimento', 'Participantes'), 2) }
        }
        GetModel()
      })
      .catch((err) => { console.log(err); setIsLoading(false) })
  }

  function CheckCalibracao(): boolean {
    return Model.itens.filter(e => e.tipo === 13).length < Model.itensCalibracao
  }

  function GetMensagemErroContinuar(): string {
    const textoPadrao = Model.itens.length === 0 ? 'Selecione pelo menos um item antes de prosseguir para etapa de configuração' : !checkElementsIsValid() ? 'Há itens com data inválida ou que ainda não estão totalmente configurados' : ''

    return (!CheckCalibracao() && Fase !== 0) ? 'A fase de entrada precisa ter um número igual ou maior de pesquisas 90º em relação aos itens de calibração na fase de desenvolvimento' : textoPadrao
  }

  function GetPesquisas90(): void {
    setIsLoading(true)
    appApi.get(`FeedbackPersonalizado/${id}/PesquisasEntrada`)
      .then((res) => {
        setPesquisasEntrada(res.data)
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function getIsChecked(checked?: boolean, text?: string): any {
    return <Flex fontSize={'14px'} alignItems={'center'} gap={'.325rem'}>
    <Flex alignItems={'center'} w={'1rem'}>
      {checked ? <FaCheckCircle color='var(--Green2)'/> : <MdOutlineCancel color='var(--Red)' fontSize={18}/>}
        </Flex>
        <Text>{text}</Text>
    </Flex>
  }

  function getIconEixo(eixo: number): any {
    switch (eixo) {
      case 0: return <FaUserCheck size={26} style={{ marginRight: '.25rem' }} />
      case 2: return <FaPeopleArrows size={26} style={{ marginRight: '.25rem' }} />
      case 3: return <FaUsers size={26} style={{ marginRight: '.25rem' }} />
      case 4: return <Img src={IconeOutros} width={26} height={26} style={{ marginRight: '.25rem' }}/>
      default: return <FaUserCheck size={26} style={{ marginRight: '.25rem' }} />
    }
  }

  function getNomeEixo(eixo: number): any {
    switch (eixo) {
      case 0: return 'Autoavaliação'
      case 2: return 'Pares'
      case 1: return 'Gestor'
      case 3: return 'Liderados'
      case 4: return 'Outros'
      case 5: return 'Gestores'
      case 6: return 'Alta liderança'
      default: return ''
    }
  }

  function checkCalibracaoPesquisa(item: iItemFeedbackResponse): boolean {
    return item.tipo === 13 && ((item.idExterno === undefined || item.idExterno === null) || (item.pesquisaCalibracaoId === undefined || item.pesquisaCalibracaoId === null))
  }

  function ReturnTextoAviso(item?: iItemFeedbackResponse): string {
    if (!item) {
      return 'Item não encontrado'
    } else {
      if (CheckIsItemDeVisualizacao(item.tipo)) {
        return ''
      }
      if (!item.idExterno && item.tipo !== 5 && item.tipo !== 6 && item.tipo !== 0 && item.tipo !== 7 && item.tipo !== 8 && item.tipo !== 1 && item.tipo !== 9 && item.tipo !== 11 && item.tipo !== 10) {
        return 'Item ainda não foi configurado'
      }
      if ((item.pesquisa && !item.pesquisa?.formulario) || (!item?.prazoPreenchimento && item?.prazoPreenchimento !== 0) || checkCalibracaoPesquisa(item)) {
        return 'Item ainda não foi totalmente configurado'
      } else if (!checkItemDuracaoIsValid(item)) {
        return 'O campo de prazo de preenchimento é obrigatório e deve ser maior que zero'
      } else {
        return ''
      }
    }
  }

  function GetInputsDeData(item: iItemFeedbackResponse, index?: number): any {
    if (CheckIsItemDeVisualizacao(item.tipo)) return <></>

    return <Flex flexDir={'column'} gap={'.75rem'}>
      <Flex flexDir={'column'} gap={'.25rem'}>
        <ElementoTooltipCmp width={'100%'} label={item.iniciado ? 'O prazo de preenchimento não pode ser alterado por aqui a partido início do feedback, por favor realize as devidas alterações no dashboard geral ou individual' : ''} bg={'var(--Red)'}>
          <Flex gap={'.75rem'} alignItems='end' w={'100%'}>
            <InputCmp
              width={item.pesquisaJaCriadaId ? '42rem' : '12rem'}
              type={'number'}
              min={0}
              label={'Prazo de preenchimento' + (item.pesquisaJaCriadaId ? ' para colaboradores que não tenham participado dessa pesquisa' : '')}
              value={item.prazoPreenchimento ?? 0}
              OnChange={(e) => setModel({ ...Model, itens: UpdateElementByPosition(Model.itens, index ?? 0, { ...item, prazoPreenchimento: parseInt(e) }) })}
              onBlur={() => onSaveItem(item, true)}
              isInvalid={!checkItemDuracaoIsValid(item)}
              isDisabled={item.iniciado}
              borderColor='var(--Gray4)'
            />
            <Flex fontWeight={600} fontSize={'14px'} w={'7.2rem'} pb={'.425rem'}>Dias corridos</Flex>
          </Flex>
        </ElementoTooltipCmp>
        {!checkItemDuracaoIsValid(item) && <Flex color={'var(--Red)'} fontSize='13px' fontWeight={400}>{ReturnTextoAviso(item)}</Flex>}
      </Flex>
    </Flex>
  }

  function updateCalibrarNineBox(propriedade: 'avaliacoesFeedback' | 'pdi' | 'indicadores', novoValor: any, item?: iItemFeedbackResponse, index?: number): void {
    const itemCopy = item?.calibrarNineBox
    if (!itemCopy) return
    itemCopy[propriedade] = novoValor
    setModel({ ...Model, itens: UpdateElementByPosition(Model.itens, index ?? 0, { ...item, calibrarNineBox: itemCopy }) })
    onSaveItem({ ...item, calibrarNineBox: itemCopy }, true)
  }

  function OnChangeEditarItensATrabalhar(val: boolean, type: number, item?: iItemFeedbackResponse, index?: number): void {
    const itemCopy = item
    if (!itemCopy?.editarItensATrabalhar) return
    if (val) {
      itemCopy.editarItensATrabalhar.push(type)
    } else {
      itemCopy.editarItensATrabalhar = itemCopy.editarItensATrabalhar.filter(e => e !== type)
    }
    setModel({ ...Model, itens: UpdateElementByPosition(Model.itens, index ?? 0, { ...itemCopy }) })
    onSaveItem({ ...itemCopy }, true)
  }

  function OnPatchStatusParticipantes(pathname: string, status: number): void {
    setIsLoading(true)
    appApi.patch(`FeedbackPersonalizado/${id}/Status?status=${status}`)
      .then(() => nav(pathname))
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function onSaveItem(item?: iItemFeedbackResponse, noToast?: boolean): void {
    appApi.put(`FeedbackPersonalizado/${id}/Item/${item?.id}?fase=${Fase}`, item)
      .then(() => {
        if (!noToast) {
          toast({
            duration: 4000,
            title: 'Item atualizado com sucesso',
            position: 'top',
            status: 'success'
          })
          setItemSelecionado(undefined)
        }
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function ReturnItemConfigurado(item?: iItemFeedbackResponse, index?: number): any {
    const tipoPesquisa = item?.tipo === 2 ? 'Quantitativa' : 'Indicativa'
    if (!item) {
      return <Flex>Item não encontrado</Flex>
    } else {
      switch (item.tipo) {
        case 0:
          return <Flex w={'100%'}>
              <ImgSah textoPersonalizado={'Esse item ainda não foi configurado, clique no botão abaixo para escolher qual modelo de pesquisa irá utilizar'} center>
                <Flex gap={'1rem'}>
                  <ButtonCmp
                    VarColor='Rosa'
                    size={'lg'}
                    onClick={() => nav(`/PesquisaCompetencias/SelecionarJaExistente?feedbackId=${id}&itemFeedbackId=${item.id}&fase=${Fase}`)}
                  >Usar pesquisa já existente</ButtonCmp>
                  <ButtonCmp
                    VarColor='Green2'
                    size={'lg'}
                    onClick={() => nav(`/Desempenho/AnaliseDesempenho/SelecionarModelo?feedbackId=${id}&itemFeedbackId=${item.id}&fase=${Fase}`)}
                  >Escolher modelo</ButtonCmp>
                </Flex>
              </ImgSah>
            </Flex>
        case 3:
        case 4:
          if (!item.idExterno) {
            return <Flex w={'100%'}>
              <ImgSah textoPersonalizado={`Esse item ainda não foi configurado, clique no botão abaixo para configurar sua avaliação ${tipoPesquisa.toLowerCase()}`} center>
                <ButtonCmp
                  VarColor='Green2'
                  size={'lg'}
                  onClick={() => nav(`/Desempenho/AnaliseDesempenho/${tipoPesquisa}/Criar?feedbackId=${id}&itemFeedbackId=${item.id}&fase=${Fase}`)}
                >Configurar avaliação</ButtonCmp>
              </ImgSah>
            </Flex>
          } else {
            return <Flex w={'100%'} flexDir='column' gap={'1.5rem'}>
              <Flex justifyContent={'space-between'}>
                <h3>{item.pesquisa?.nome}</h3>
                {!item.pesquisaJaCriadaId && !item.iniciado && <ButtonCmp
                  VarColor='Green2'
                  size={'lg'}
                  onClick={() => nav(item.pesquisa?.formulario ? `/Desempenho/AnaliseDesempenho/${tipoPesquisa}/EnviarPesquisa/${item.pesquisa?.id}` : `/Desempenho/AnaliseDesempenho/${tipoPesquisa}/Formularios/${item.pesquisa?.id}`)}
                  width={'12rem'}
                >Configurar avaliação</ButtonCmp>}
              </Flex>
              <Flex flexDir={'column'} gap={'1.25rem'}>
                <Text fontSize={'14px'} fontWeight={600}>Participantes</Text>
                <Flex gap={'2rem'}>
                  {item.pesquisa?.participantes.sort((a, b) => a - b).map((e, i) => {
                    return (
                      <Flex flexDir={'column'} fontSize={'.875rem'} alignItems={'center'} pr={'2rem'} borderRight={item.pesquisa?.participantes.length !== (i + 1) ? '2px dashed var(--Azul)' : ''} gap={'.25rem'}>
                          <Flex alignItems={'center'} color={'var(--Azul)'}>
                              {getIconEixo(e)}
                          </Flex>
                          <Text style={{ color: 'black', fontWeight: 400 }}>{getNomeEixo(e)}</Text>
                      </Flex>
                    )
                  })}
                </Flex>
              </Flex>
              {getIsChecked(item.pesquisa?.encerrarAutomaticamente, 'Encerrar automaticamente quando todas as pesquisas do avaliado forem respondidas')}
              <Flex flexDir={'column'} gap={'.5rem'}>
                <Text fontSize={'14px'} fontWeight={600}>Formulário</Text>
                {item.pesquisa?.formulario
                  ? <Flex gap={'1rem'}>
                    <Carousel className='carousel-root-2' infiniteLoop showArrows showIndicators={false} width={'100%'}>
                      {ArrayToChunks(item.pesquisa.formulario.competenciasPop, 4).map(comps => {
                        return <Grid gridTemplateColumns={'repeat(4, 1fr)'} gap={'1rem'} px={'2rem'} py={'.5rem'}>
                          {comps.map(c => {
                            return <CardCompetencia Competencia={c}
                            onClickPreVisualizar={() => {
                              setCompetencia(c)
                              setQuestoes(c.questoes)
                              setPreVisualizarisOpen(true)
                            }}/>
                          })}
                        </Grid>
                      })}
                  </Carousel>
                  </Flex>
                  : <Flex gap={'.325rem'} alignItems='center' fontSize={'14px'}>
                    <MdOutlineCancel color='var(--Red)' fontSize={16}/>
                  <Text>Ainda não foi configurado</Text>
                </Flex>}
              </Flex>
              {getIsChecked(item.pesquisa?.usarCompetenciasPdi, 'Adicionar as competências trabalhadas do último PDI no formulário de cada avaliado')}
              <Flex flexDir={'column'} gap={'.75rem'}>
                <Text fontSize={'14px'} fontWeight={600}>Reenviar convites para quem não respondeu</Text>
                {(!item.pesquisa?.reenviarConvites || item.pesquisa?.reenviarConvites.length === 0) && <Flex gap={'.325rem'} alignItems={'center'}>
                    <Flex w={'1rem'} h={'1rem'} alignItems={'center'}><MdOutlineCancel color='var(--Red)' size={'16px'}/></Flex>
                    <Text fontSize={'14px'}>Reenvio automático desativado</Text>
                </Flex>}
                {item?.pesquisa?.reenviarConvites && <Flex gap={'2rem'}>
                    {
                      ArrayToChunks(item?.pesquisa?.reenviarConvites?.sort((a, b) => b - a), 2).map(dias => {
                        return <Flex flexDir={'column'}>
                          {dias.map(e => {
                            return <Flex fontSize={'14px'} gap={'.325rem'} alignItems={'center'}>
                              <FaCheckCircle color='var(--Green2)'/>
                              {e} dia{e === 1 ? '' : 's'} antes de encerrar a pesquisa
                            </Flex>
                          })}
                        </Flex>
                      })
                    }
                </Flex>}
              </Flex>
              {GetInputsDeData(item, index)}
              {!item.iniciado && <Flex justifyContent={'end'}>
                <ButtonCmp VarColor='Green2' width={'10rem'} onClick={() => { onSaveItem(item) }} leftIcon={<FaSave/>}>Salvar alterações</ButtonCmp>
              </Flex>}
            </Flex>
          }
        case 13: {
          return <Flex w={'100%'} flexDir='column' gap={'1.5rem'}>
            <Flex flexDir={'column'} gap={'.325rem'}>
              <SelectCmp isDisabled={item.iniciado} value={item?.pesquisaCalibracaoId} OnChange={(e) => { setModel({ ...Model, itens: UpdateElementByPosition(Model.itens, index ?? 0, { ...item, pesquisaCalibracaoId: e === '' ? undefined : e }) }); onSaveItem({ ...item, pesquisaCalibracaoId: e === '' ? undefined : e }, true) }} title={'Selecione a pesquisa 90º que será realizada a calibração'}>
                <option value={''}>Selecione uma pesquisa</option>
                {getPesquisas90().map(e => {
                  return <option value={e.id}>{e.nome}</option>
                })}
              </SelectCmp>
              {getPesquisas90().length === 0 && <Text fontSize={'12px'} color={'var(--Red)'}>Não há nenhuma pesquisa 90º disponível para selecionar</Text>}
            </Flex>
            <CheckboxCmp isChecked={item.colaboradorPodeVisualizarCalibracao} OnChange={(e) => { setModel({ ...Model, itens: UpdateElementByPosition(Model.itens, index ?? 0, { ...item, colaboradorPodeVisualizarCalibracao: e }) }); onSaveItem({ ...item, colaboradorPodeVisualizarCalibracao: e }, true) }}>Participante (quem receberá o feedback) poderá visualizar o resultado da calibração</CheckboxCmp>
            {GetInputsDeData(item, index)}
            {!item.iniciado && <Flex justifyContent={'end'}>
              <ButtonCmp VarColor='Green2' width={'10rem'} onClick={() => { onSaveItem(item) }} leftIcon={<FaSave/>}>Salvar alterações</ButtonCmp>
            </Flex>}
          </Flex>
        }
        case 5: {
          if (!item.idExterno) {
            return <Flex w={'100%'}>
              <ImgSah textoPersonalizado={'Esse item ainda não foi configurado, clique no botão abaixo para configurar seu formulário'} center>
                <ButtonCmp
                  VarColor='Green2'
                  size={'lg'}
                  onClick={() => nav(`/Jornada/PesquisaInterna/Criar?feedbackId=${id}&itemFeedbackId=${item.id}&fase=${Fase}`)}
                >Configurar formulário</ButtonCmp>
              </ImgSah>
            </Flex>
          } else if (item.pesquisaInterna?.formularioPendente && item.idExterno) {
            return <Flex w={'100%'}>
              <ImgSah textoPersonalizado={'Esse item ainda não foi totalmente configurado, clique no botão abaixo para terminar de configurar seu formulário'} center>
                <ButtonCmp
                  VarColor='Green2'
                  size={'lg'}
                  onClick={() => nav(`/Jornada/PesquisaInterna/${item.idExterno}/Formularios?feedbackId=${id}&itemFeedbackId=${item.id}&fase=${Fase}`)}
                >Configurar formulário</ButtonCmp>
              </ImgSah>
            </Flex>
          } else {
            return <Flex w={'100%'} flexDir='column' gap={'1.5rem'}>
            <Flex flexDir={'column'} gap={'1rem'}>
              <Flex justifyContent={'space-between'} alignItems={'center'}>
                <Flex flexDir={'column'}>
                  <h3>{item.pesquisaInterna?.nome}</h3>
                  {item.pesquisaInterna?.descricao && <span>Descrição: <strong>{item.pesquisaInterna?.descricao}</strong></span>}
                </Flex>
                {!item.iniciado && <ButtonCmp onClick={() => nav(`/Jornada/PesquisaInterna/Configuracao/${item.idExterno}?feedbackId=${id}&itemFeedbackId=${item.id}&fase=${Fase}`)} leftIcon={<FaEdit/>} VarColor={'Green2'}>Editar</ButtonCmp>}
              </Flex>
            </Flex>
            <Main>
                <div>
                    <Text fontSize={'14px'} mb={'.5rem'} fontWeight={600}>Dados do formulário</Text>
                </div>
                <span>Questões: <strong>{item.pesquisaInterna?.totalQuestoes}</strong></span>
                <span>Questões de múltipla escolha: <strong>{item.pesquisaInterna?.totalQuestoesMultiplaEscolha}</strong></span>
                <span>Questões de caixa de seleção: <strong>{item.pesquisaInterna?.totalQuestoesCaixaSelecao}</strong></span>
                <span>Questões discursivas: <strong>{item.pesquisaInterna?.totalQuestoesDiscursiva}</strong></span>
                <span>Questões de escala: <strong>{item.pesquisaInterna?.totalQuestoesEscala}</strong></span>
            </Main>
            {GetInputsDeData(item, index)}
            {item.pesquisaInterna?.respondenteResponsavelFeedback && <CheckboxCmp isDisabled={item.iniciado} isChecked={item.configFormulario?.mostrarRespostasDoGestor} OnChange={(e) => {
              setModel({ ...Model, itens: UpdateElementByPosition(Model.itens, index ?? 0, { ...item, configFormulario: { ...item.configFormulario, mostrarRespostasDoGestor: e } }) })
              onSaveItem({ ...item, configFormulario: { ...item.configFormulario, mostrarRespostasDoGestor: e } }, true)
            }}>O participante (quem receberá o feedback) terá acesso às respostas do gestor</CheckboxCmp>}
            <Flex flexDir={'column'} gap={'.325rem'}>
              <Text fontSize={'14px'} fontWeight={600}>Selecione abaixo quem poderá editar as respostar após o preenchimento do formulário</Text>
              <Flex gap={'1.5rem'} alignItems={'center'}>
                <CheckboxCmp isDisabled={item.iniciado} isChecked={item.configFormulario?.editarRespostas?.includes(0)} OnChange={(e) => OnSelectEditarRespostas(item, 0, e, index)}>Participante (quem recebe o feedback)</CheckboxCmp>
                {item.pesquisaInterna?.respondenteResponsavelFeedback && <CheckboxCmp isDisabled={item.iniciado} isChecked={item.configFormulario?.editarRespostas?.includes(1)} OnChange={(e) => OnSelectEditarRespostas(item, 1, e, index)}>Gestor</CheckboxCmp>}
              </Flex>
            </Flex>
            {!item.iniciado && <Flex justifyContent={'end'}>
              <ButtonCmp VarColor='Green2' width={'10rem'} onClick={() => { onSaveItem(item) }} leftIcon={<FaSave/>}>Salvar alterações</ButtonCmp>
            </Flex>}
          </Flex>
          }
        }
        case 12: {
          return <Flex w={'100%'} flexDir='column' gap={'1.5rem'}>
            <Flex flexDir={'column'} gap={'.325rem'}>
              <h2>Calibrar 9Box do participante</h2>
              <Text fontSize={'14px'} fontWeight={400} color={'var(--Gray3)'}>Será feito uma calibração do participante, podendo puxar dado de itens anteriores do feedback</Text>
            </Flex>
            <Flex gap={'.75rem'}>
              <Flex
                flexDir={'column'}
                gap={'1rem'}
              >
                <Text fontWeight={'700'} fontSize={'14px'} mb={'.5rem'}>Dados para analisar antes da calibração</Text>
                <CheckboxCmp isDisabled={item.iniciado} isChecked={item.calibrarNineBox?.avaliacoesFeedback} OnChange={(e) => updateCalibrarNineBox('avaliacoesFeedback', e, item, index)}>Pesquisa de desempenho mais recente do colaborador</CheckboxCmp>

                <CheckboxCmp isDisabled={item.iniciado} isChecked={item.calibrarNineBox?.pdi} OnChange={(e) => updateCalibrarNineBox('pdi', e, item, index)}>PDI anterior</CheckboxCmp>

                <CheckboxCmp isDisabled={item.iniciado} isChecked={item.calibrarNineBox?.indicadores} OnChange={(e) => updateCalibrarNineBox('indicadores', e, item, index)}>Indicadores de performance do colaborador ou de sua área</CheckboxCmp>
              </Flex>
              {ModelNineBox && <NineBox model={ModelNineBox}/>}
            </Flex>
            {GetInputsDeData(item, index)}
            {!item.iniciado && <Flex justifyContent={'end'}>
              <ButtonCmp VarColor='Green2' width={'10rem'} onClick={() => { onSaveItem(item) }} leftIcon={<FaSave/>}>Salvar alterações</ButtonCmp>
            </Flex>}
          </Flex>
        }
        case 15: {
          return <Flex w={'100%'} flexDir='column' gap={'1.5rem'}>
            {GetInputsDeData(item, index)}
            {!item.iniciado && <Flex justifyContent={'end'} gap={'1rem'}>
              <ButtonCmp VarColor='Rosa' width={'11rem'} onClick={() => { nav('/Jornada/Formulario/PercepcoesEmpresa') }} leftIcon={<FaCog/>}>Configurar questões</ButtonCmp>
              <ButtonCmp VarColor='Green2' width={'10rem'} onClick={() => { onSaveItem(item) }} leftIcon={<FaSave/>}>Salvar alterações</ButtonCmp>
            </Flex>}
          </Flex>
        }
        case 14: {
          return <Flex w={'100%'} flexDir='column' gap={'1.5rem'}>
            <Flex flexDir={'column'} gap={'.75rem'}>
              <Text fontSize={'14px'} fontWeight={'600'}>Quem poderá editar os itens priorizados:</Text>
              <Flex gap={'1rem'}>
                <CheckboxCmp OnChange={(val) => OnChangeEditarItensATrabalhar(val, 0, item, index)} isChecked={item.editarItensATrabalhar?.includes(0)}>Gestor</CheckboxCmp>
                <CheckboxCmp OnChange={(val) => OnChangeEditarItensATrabalhar(val, 1, item, index)} isChecked={item.editarItensATrabalhar?.includes(1)}>Participante (quem receberá o feedback)</CheckboxCmp>
              </Flex>
            </Flex>
            <Flex flexDir={'column'} gap={'.5rem'}>
              <Text fontSize={'14px'} fontWeight={'600'}>Selecione o responsável por subir o PDI do colaborador</Text>
              <RadioGroup d={'flex'} gap={'.5rem'} flexDir={'column'} value={item.responsavelPDI?.toString()} onChange={(e) => { setModel({ ...Model, itens: UpdateElementByPosition(Model.itens, index ?? 0, { ...item, responsavelPDI: parseInt(e) }) }); onSaveItem({ ...item, responsavelPDI: parseInt(e) }, true) }} isDisabled={item.iniciado} size={'sm'}>
                <Radio value={'0'}>Gestor</Radio>
                <Radio value={'1'}>Participante</Radio>
              </RadioGroup>
            </Flex>
            {GetInputsDeData(item, index)}
            {!item.iniciado && <Flex justifyContent={'end'}>
              <ButtonCmp VarColor='Green2' width={'10rem'} onClick={() => { onSaveItem(item) }} leftIcon={<FaSave/>}>Salvar alterações</ButtonCmp>
            </Flex>}
          </Flex>
        }
        case 11: {
          if (!item.idExterno) {
            return <Flex w={'100%'}>
              <ImgSah textoPersonalizado={'Esse item ainda não foi configurado, clique no botão abaixo para configurar sua Reunião 1:1'} center>
                <ButtonCmp
                  VarColor='Green2'
                  size={'lg'}
                  onClick={() => nav(`/Desempenho/NovaReuniaoOne/Criar?feedbackId=${id}&itemFeedbackId=${item.id}&fase=${Fase}&tipo=${item.tipo}`)}
                >Configurar reunião 1:1</ButtonCmp>
              </ImgSah>
            </Flex>
          } else {
            return <Flex w={'100%'} flexDir='column' gap={'1.5rem'}>
            <Flex flexDir={'column'} gap={'1rem'}>
              <Flex justifyContent={'space-between'} alignItems={'center'}>
                <h3>{item.reuniaoOne?.assunto}</h3>
                {!item.iniciado && <ButtonCmp onClick={() => nav(`/Desempenho/NovaReuniaoOne/Editar/${item.idExterno}?feedbackId=${id}&itemFeedbackId=${item.id}&fase=${Fase}`)} leftIcon={<FaEdit/>} VarColor={'Green2'}>Editar</ButtonCmp>}
              </Flex>
              <Flex flexDir={'column'} gap={'.5rem'} fontSize={'14px'}>
                <Flex gap={'.325rem'}>Duração: <strong>{transformarDuracao(item.reuniaoOne?.duracao ?? 5)}</strong></Flex>
                {item.reuniaoOne?.descricao && <Flex gap={'.325rem'} alignItems={'center'}>Descrição: <strong dangerouslySetInnerHTML={{ __html: FormatarMensagemEditorDeTexto(item.reuniaoOne?.descricao ?? '') }}></strong></Flex>}
                {item.reuniaoOne?.local && <Flex gap={'.325rem'}>Local: <strong>{item.reuniaoOne?.local}</strong></Flex>}
                {getIsChecked(true, item.reuniaoOne?.presencial ? 'Presencial' : 'Remoto')}
                {getIsChecked(item.reuniaoOne?.lembrete, 'Lembretes de envio e push')}
                {getIsChecked(item.reuniaoOne?.liberarFinalizar, 'Colaborador pode finalizar a reunião')}
              </Flex>
            </Flex>
            {GetInputsDeData(item, index)}
            {!item.iniciado && <Flex justifyContent={'end'}>
              <ButtonCmp VarColor='Green2' width={'10rem'} onClick={() => { onSaveItem(item) }} leftIcon={<FaSave/>}>Salvar alterações</ButtonCmp>
            </Flex>}
          </Flex>
          }
        }
      }
    }
  }

  function checkItemDuracaoIsValid(item: iItemFeedbackResponse): boolean {
    if ((item.prazoPreenchimento === null) || (CheckIsItemDeVisualizacao(item.tipo) && item.prazoPreenchimento === 0)) return true

    if (item.prazoPreenchimento === undefined || item.prazoPreenchimento === null || item.prazoPreenchimento === 0) return false

    if (item.tipo === 13 && item.pesquisaCalibracaoId !== undefined && item.pesquisaCalibracaoId !== null) {
      const itemPesquisa = Model.itens.find(e => e.idExterno === item.pesquisaCalibracaoId)
      if ((item.prazoPreenchimento !== undefined && item.prazoPreenchimento !== null) && (itemPesquisa?.prazoPreenchimento !== undefined && itemPesquisa?.prazoPreenchimento !== null) && itemPesquisa?.prazoPreenchimento >= item.prazoPreenchimento) {
        return false
      }
    }

    return true
  }

  function getPesquisas90(): iPesquisaPercepcaoFeedbackResponse[] {
    return PesquisasEntrada
  }

  function checkUniqueElementIsValid(item: iItemFeedbackResponse): boolean {
    if (CheckIsItemDeVisualizacao(item.tipo)) return true

    if (item.tipo === 3 || item.tipo === 4 || item.tipo === 11 || item.tipo === 5) {
      if (item.idExterno === undefined || item.idExterno === null) {
        return false
      }

      if (item.prazoPreenchimento === 0 || item.prazoPreenchimento === undefined || item.prazoPreenchimento === null) {
        return false
      }
    }

    if (item.tipo === 13) {
      if (item.pesquisaCalibracaoId === undefined || item.pesquisaCalibracaoId === null) {
        return false
      }
    }

    if (!checkItemDuracaoIsValid(item)) {
      return false
    }

    if (!CheckIsItemDeVisualizacao(item.tipo) && (item.prazoPreenchimento === undefined || item.prazoPreenchimento === null)) {
      return false
    }

    return true
  }

  function checkElementsIsValid(): boolean {
    let response = true
    Model.itens.forEach(item => {
      if (response) response = checkUniqueElementIsValid(item)
    })

    return response
  }

  function getNineBox(): void {
    appApi.get('NineBox/Padrao')
      .then(res => {
        setModelNineBox(res.data)
      })
      .catch(err => console.log(err))
  }

  function onSelect(tipo: number): void {
    const newItem = { ordem: CheckIsItemDeVisualizacao(tipo) ? undefined : -1, tipo: tipo, obrigatorio: true, idExterno: null }
    if (CheckIsItemDeVisualizacao(tipo)) {
      const copy: any[] = [...Model.itens.filter(e => !CheckIsItemPadrao(e.tipo))]
      copy.push(newItem)
      Model.itens.filter(e => CheckIsItemPadrao(e.tipo)).forEach(e => {
        copy.push(e)
      })
      setModel({ ...Model, itens: copy })
      OnSave(copy, true)
    } else {
      const copy: any[] = Model.itens.filter(e => !CheckIsItemDeVisualizacao(e.tipo))
      copy.push({ ...newItem, ordem: copy.length + 1 })
      Model.itens.forEach(e => {
        if (CheckIsItemDeVisualizacao(e.tipo)) {
          copy.push({ ...e, ordem: e.ordem ? e.ordem + 1 : undefined })
        }
      })
      setModel({ ...Model, itens: copy })
      OnSave(copy, true)
    }
    toast({
      title: 'Item adicionado com sucesso',
      duration: 2000,
      position: 'top',
      status: 'success'
    })
  }

  useEffect(() => {
    GetModel()
    getNineBox()
    GetPesquisas90()
  }, [])

  useEffect(() => {
    GetModel()
  }, [pathname])

  return (
    <Body isLoading={IsLoading}>
      {Competencia && <ModalPreVizualizarQuestao
        Competencia={Competencia}
        Questoes={Questoes}
        OnCloseModal={() => {
          setPreVisualizarisOpen(false)
          setQuestoes([])
          setCompetencia(undefined)
        }}
        isOpen={PreVisualizarisOpen}
      />}
      {ItemSelecionado && <ModalConfigurarItem
        isOpen
        OnCloseModal={() => setItemSelecionado(undefined)}
        children={ReturnItemConfigurado(Model.itens.find(e => !CheckIsItemPadrao(e.tipo) && e.ordem === ItemSelecionado), Model.itens.findIndex(e => !CheckIsItemPadrao(e.tipo) && e.ordem === ItemSelecionado))}
        tipo={Model.itens.find(e => !CheckIsItemPadrao(e.tipo) && e.ordem === ItemSelecionado)?.tipo ?? 0}
      />}
      <ModalDelete
        isOpen={!!OrdemDelete}
        message={'Tem certeza que deseja remover esse item?'}
        onConfirm={() => {
          OnDeleteItem(OrdemDelete?.tipo ?? 0, OrdemDelete?.ordem)
        }}
        onRequestClose={() => setOrdemDelete(undefined)}
        center
      />
      <TimelineFeedback id={id ?? ''}/>
      <Box>
        <Flex flexDir={'column'} mb={'1.25rem'} mt={'1rem'}>
          <h3>Clique nos cards abaixo para selecionar {Fase === 0 ? 'as informações que serão utilizadas no feedback' : 'os itens de condução do feedback​'}</h3>
        </Flex>
        <Flex flexDir={'column'} gap={'1.25rem'}>
          <WhiteContainer>
            <Flex flexDir={'column'} gap={'.5rem'}>
              {Fase === 0 && <Flex mb={'.5rem'} alignItems={'center'} gap={'.5rem'}>
                <Text fontWeight={600}>Itens que requerem preenchimento prévio:</Text>
              </Flex>}
              <Grid gridTemplateColumns={'repeat(4, 1fr)'} gap={'1rem 1.5rem'} alignItems={'center'}>
                {Model.itensPermitidos?.filter(item => !CheckIsItemDeVisualizacao(item) && item !== 12 && item !== 15).sort((a, b) => a - b).map(item => {
                  if (item === 13) {
                    return (<Flex flexDir={'column'} gap={'1rem'}>
                      <CardSelecao
                        onSelect={onSelect}
                        isVisualizacao={CheckIsItemDeVisualizacao(item)}
                        quantidadeItens={Model.itens.filter(e => e.tipo === item).length}
                        tipo={item}
                        canSelectCalibracao={CheckCalibracao()}
                        iniciado={Model.iniciado}
                      />
                      <CardSelecao
                        onSelect={onSelect}
                        isVisualizacao={CheckIsItemDeVisualizacao(12)}
                        quantidadeItens={Model.itens.filter(e => e.tipo === 12).length}
                        tipo={12}
                        canSelectCalibracao={CheckCalibracao()}
                        iniciado={Model.iniciado}
                      />
                    </Flex>)
                  }
                  if (item === 5 && Model.itensPermitidos?.includes(15)) {
                    return (<Flex flexDir={'column'} gap={'1rem'}>
                      <CardSelecao
                        onSelect={onSelect}
                        isVisualizacao={CheckIsItemDeVisualizacao(15)}
                        quantidadeItens={Model.itens.filter(e => e.tipo === 15).length}
                        tipo={15}
                        canSelectCalibracao={CheckCalibracao()}
                        iniciado={Model.iniciado}
                      />
                      <CardSelecao
                        onSelect={onSelect}
                        isVisualizacao={CheckIsItemDeVisualizacao(item)}
                        quantidadeItens={Model.itens.filter(e => e.tipo === item).length}
                        tipo={item}
                        canSelectCalibracao={CheckCalibracao()}
                        iniciado={Model.iniciado}
                      />
                    </Flex>)
                  }
                  return (<CardSelecao
                    onSelect={onSelect}
                    isVisualizacao={CheckIsItemDeVisualizacao(item)}
                    quantidadeItens={item === 0 ? Model.itens.filter(e => e.tipo === item || e.tipo === 3 || e.tipo === 4).length : Model.itens.filter(e => e.tipo === item).length}
                    tipo={item}
                    pdiLiberado={Model.pesquisasDesempenho > 0}
                    canSelectCalibracao={CheckCalibracao()}
                    iniciado={Model.iniciado}
                  />)
                })}
              </Grid>
            </Flex>
            {Fase === 0 && <Flex flexDir={'column'} gap={'.5rem'} mt={'1.5rem'}>
              <Flex mb={'.5rem'} alignItems={'center'} gap={'.5rem'}>
                <Text fontWeight={600}>Itens disponíveis de eventos anteriores:</Text>
              </Flex>
              <Grid gridTemplateColumns={'repeat(4, 1fr)'} gap={'1rem 1.5rem'}>
                {Model.itensPermitidos?.filter(item => CheckIsItemDeVisualizacao(item)).sort((a, b) => a - b).map(item => {
                  return (<CardSelecao
                    onSelect={onSelect}
                    isVisualizacao={CheckIsItemDeVisualizacao(item)}
                    quantidadeItens={Model.itens.filter(e => e.tipo === item).length}
                    tipo={item}
                    canSelectCalibracao={CheckCalibracao()}
                    iniciado={Model.iniciado}
                  />)
                })}
              </Grid>
            </Flex>}
            <Divider my={'1rem'} borderColor={'var(--c6)'} opacity={'.75'}/>
            <Flex mb={'1rem'}>
              <h3>Itens selecionados</h3>
            </Flex>
            <Flex flexDir={'column'}>
              <Grid pr={'1.5rem'} mb={'.5rem'} gridTemplateColumns={'4rem auto 12rem'} gap={'2rem'} fontSize={'14px'} fontWeight={'600'} color={'var(--Gray2)'}>
                <Flex pl={'1rem'}>Ordem</Flex>
                <Grid gap={'.75rem'} gridTemplateColumns={'12rem 1fr 7rem'}>
                  <Flex>Item</Flex>
                  <Flex>Descrição</Flex>
                  <Flex>Status</Flex>
                </Grid>
                <Flex>Opções</Flex>
              </Grid>
              {Model.itens.filter(e => e.ordem).sort((a, b) => { if (a.ordem && b.ordem) { return a.ordem - b.ordem } else { return 0 } }).map(e => {
                return <CardItemSelecionado
                  onDescerItem={OnDescerItem}
                  onSubirItem={OnSubirItem}
                  onRemove={setOrdemDelete}
                  onUpdate={OnUpdate}
                  item={e}
                  configuracaoPendente={!checkUniqueElementIsValid(e)}
                  quantidadeItens={Model.itens.filter(e => e.ordem).length}
                  firstItem={false}
                  onConfigurar={setItemSelecionado}
                  iniciado={Model.iniciado}
                />
              })}
              {Model.itens.filter(e => !e.ordem).sort((a, b) => Number(CheckIsItemPadrao(a.tipo)) - Number(CheckIsItemPadrao(b.tipo))).map((e, i) => {
                return <CardItemSelecionado
                  onDescerItem={OnDescerItem}
                  onSubirItem={OnSubirItem}
                  onRemove={setOrdemDelete}
                  item={e}
                  onUpdate={OnUpdate}
                  firstItem={i === 0 && Model.itens.filter(e => e.ordem).length === 0}
                  configuracaoPendente={!checkUniqueElementIsValid(e)}
                  quantidadeItens={Model.itens.length}
                  onConfigurar={setItemSelecionado}
                  iniciado={Model.iniciado}
                />
              })}
            </Flex>
          </WhiteContainer>
        </Flex>

        <Flex justifyContent={'end'} marginTop='1rem' gap={'.5rem'}>
          <ButtonCmp
            VarColor={'c6'}
            onClick={() => nav(-1)}
          >Voltar</ButtonCmp>
          <ElementoTooltipCmp bg={'var(--Red)'} label={(Model.itens.filter(e => !CheckIsItemDeVisualizacao(e.tipo)).length === 0 || !checkElementsIsValid()) ? GetMensagemErroContinuar() : ''}>
            <ButtonCmp
              onClick={() => OnSave(Model.itens)}
              VarColor='Green2'
              isDisabled={Model.itens.filter(e => !CheckIsItemDeVisualizacao(e.tipo)).length === 0 || !checkElementsIsValid()}
            >Salvar e continuar</ButtonCmp>
          </ElementoTooltipCmp>
        </Flex>
      </Box>
    </Body>
  )
}
